import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiInputPhoneModule } from "@taiga-ui/kit";
import { KwikUIInputAadhaarComponent } from "./input-aadhaar.component";

@NgModule({
  declarations: [KwikUIInputAadhaarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiInputPhoneModule
  ],
  exports: [KwikUIInputAadhaarComponent]
})
export class KwikUIInputAadhaarModule {}
